import { render, staticRenderFns } from "./FormAddBtn.vue?vue&type=template&id=566bc923"
import script from "./FormAddBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormAddBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports